import { Label, Select } from "components"
import { useDepartement } from "pages/Card/Transaction/CreateNewEmployee/components/FormSection/utils"
import { Controller, useFormContext } from "react-hook-form"
import { TaskType } from "../types"

type DropdownDepartmentProps = {
  approvalView?: boolean
  isDisabled?: boolean
}

export const DropdownDepartment = ({
  approvalView,
  isDisabled
}: DropdownDepartmentProps) => {
  const { control, setValue } = useFormContext<TaskType>()
  const departments = useDepartement()
  const dropdown = departments?.dataDepartement ?? []

  return (
    <section>
      <Label text="DEPARTMENT" />

      <section className="flex gap-3">
        <Controller
          control={control}
          name="department_id"
          render={({ field, fieldState }) => (
            <Select
              ref={field.ref}
              className="grow"
              placeholder="Select Department"
              isLoading={departments?.isLoadingDepartement}
              isDisabled={isDisabled || approvalView}
              options={dropdown ?? []}
              value={
                field.value
                  ? dropdown.find(
                      (item) => item.value === field.value?.toString()
                    )
                  : null
              }
              onChange={(e) => {
                if (e?.value) {
                  field.onChange(e?.value)
                  setValue("department_name", e?.label)
                }
              }}
              error={fieldState.error?.message}
            />
          )}
        />
      </section>
    </section>
  )
}
